import Button from "@mui/material/Button";
import {
  Alert,
  AlertTitle,
  AppBar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  IconButton,
  Snackbar,
  Tooltip,
  Box
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { CustomBreadCrumb } from "../utilities/Breadcrumbs";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import discountIcon from 'src/assets/tag.png';
import { useTheme } from "@mui/material/styles";

const FormPageHeader = ({
  handleSubmit,
  snackState,
  onBtExport,
  successMsg,
  saveDisable,
  saveDisabledHint,
  componentName,
  handleDelete,
  handleCancel,
  hideDelete,
  saveAndSaveDisable,
  breadCrumbSeperator,
  currentPage,
  specialDiscount,
  BreadcrumbText,
  parentBreadcrumbData,
  error,
  children,
  sidebar,
  showLedgersList,
  headerInputFields,
  saveAndSend,
  orderHeaderAction,
  gridRef,
  hideButtons,
}) => {
  const [open, setOpen] = useState(false);
  const [openSnack, setOpenSnack] = useState(snackState || false);
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackClose = () => {
    setOpenSnack(false);
  };

  const handleDeleteData = () => {
    setOpen(false);
    handleDelete();
  };

  const handleDefaultGridState = () => {
    if (!gridRef.current) return;
    gridRef.current.api.setFilterModel(null);
    gridRef.current.columnApi.resetColumnState();

    if (componentName === "Container Management") {
      const allColumnIds = [];
      gridRef.current.columnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.getColId());
      });
      gridRef.current.columnApi.autoSizeColumns(allColumnIds);
    }
  };

  useEffect(() => {
    setOpenSnack(snackState);
  }, [snackState]);

  const saveButton = (
    <Button
      type="submit"
      onClick={handleSubmit}
      variant="contained"
      color="secondary"
      disabled={saveDisable}
    >
      <FuseSvgIcon>material-solid:save</FuseSvgIcon>
    </Button>
  );
  const saveDisabledTip = saveDisable && saveDisabledHint;

  return (
    <>
      <AppBar
        color="inherit"
        sx={{ zIndex: 1200, borderRadius: 0 }}
        className={sidebar ? "sticky top-0 z-20" : "sticky z-20"}
      >
        <div className="flex flex-col md:flex-row md:flex-nowrap flex-1 w-full items-start md:items-center justify-between py-10 px-16 sm:px-24 gap-16">
          <div className="text-20 sm:text-24 md:text-32 font-extrabold tracking-tight w-full md:w-auto min-w-0">
            <div className="flex items-center">
              <h2 className="break-words">
                {currentPage && currentPage?.toUpperCase()}
              </h2>
              {specialDiscount === "APPROVED" ? (
                <FuseSvgIcon
                  size={18}
                  color="Green"
                  style={{ marginLeft: "16px" }}
                >
                  heroicons-solid:tag
                </FuseSvgIcon>
              ) : specialDiscount === "WAITING" ||
                specialDiscount === "PENDING" ? (
                <FuseSvgIcon
                  size={18}
                  color="Red"
                  style={{ marginLeft: "16px" }}
                >
                  heroicons-solid:tag
                </FuseSvgIcon>
              ) : (
                ""
              )}
            </div>
            {parentBreadcrumbData && (
              <CustomBreadCrumb
                seperator={breadCrumbSeperator}
                currentPage={BreadcrumbText ? BreadcrumbText : currentPage}
                parentData={parentBreadcrumbData}
              />
            )}
          </div>
          <div className="flex flex-col w-full md:w-auto items-start md:items-end flex-1">
            <Box className="flex flex-wrap items-center gap-8 justify-start md:justify-end w-full">
              {orderHeaderAction && orderHeaderAction}
              {handleSubmit && !hideButtons && (
                <Tooltip
                  title={saveDisabledTip ? saveDisabledHint : "Save " + componentName}
                >
                  {saveDisabledTip ? <span>{saveButton}</span> : saveButton}
                </Tooltip>
              )}
              {saveAndSend && !hideButtons && (
                <Tooltip title={"Save & Send " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={saveAndSend}
                    disabled={saveAndSaveDisable}
                  >
                    <FuseSvgIcon>material-solid:send</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {handleCancel && !hideButtons && (
                <Tooltip title={"Cancel " + currentPage}>
                  <Button
                    onClick={handleCancel}
                    variant="contained"
                    color="secondary"
                  >
                    <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {handleDelete && !hideDelete && !hideButtons && (
                <Tooltip title={"Delete " + componentName}>
                  <Button
                    onClick={(e) => setOpen(true)}
                    variant="contained"
                    color="error"
                  >
                    <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {onBtExport && (
                <Tooltip title={"Export " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={onBtExport}
                    style={{ fontWeight: "bold" }}
                  >
                    <FuseSvgIcon>heroicons-solid:save</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {gridRef && (
                <Tooltip title={"Default Grid State"}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleDefaultGridState}
                    style={{ fontWeight: "bold" }}
                  >
                    <FuseSvgIcon>material-outline:grid_on</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {showLedgersList && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={showLedgersList}
                >
                  <FuseSvgIcon>material-outline:view_list</FuseSvgIcon>
                </Button>
              )}
              {headerInputFields && headerInputFields}
            </Box>
            {handleDelete && (
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleDeleteData}>Yes</Button>
                  <Button onClick={handleClose} autoFocus>
                    No
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          </div>
        </div>
        {error && (
          <Alert severity="error" variant="filled" className="mb-16">
            <AlertTitle>Error</AlertTitle>
            {error}
          </Alert>
        )}
      </AppBar>

      <div className="w-full pt-3 pb-1 px-0">{children}</div>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnack}
        autoHideDuration={6000}
        disableWindowBlurListener={true}
        onClose={handleSnackClose}
        sx={{ top: "60px !important" }}
      >
        <Alert
          onClose={handleSnackClose}
          severity="success"
          variant="filled"
          sx={{
            width: "100%",
            bgcolor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
          }}
        >
          {successMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FormPageHeader;